export const textProps = {
    title: String,
    title_tag: String,
    text: String,
    background: String,
}

export const optionsProps = {
    acf_fc_layout: String,
    section_visibility: Boolean,
    section_id: String,
    additional_classes: String,
    section_padding: String,
}